import { motion } from "framer-motion";
import { MousePointerClick, CreditCard, Cpu, Mail, Rocket } from "lucide-react";
import { SectionHeader } from "./SectionHeader";

const steps = [
  { icon: MousePointerClick, title: "Pilih Paket", desc: "Klik tombol Order Sekarang" },
  { icon: CreditCard, title: "Bayar", desc: "Selesaikan pembayaran dengan aman" },
  { icon: Cpu, title: "Sistem Otomatis", desc: "Sistem memproses tanpa antre" },
  { icon: Mail, title: "Dikirim Otomatis", desc: "Akun masuk ke Email & WhatsApp Anda" },
  { icon: Rocket, title: "Langsung Pakai", desc: "Nikmati semua fitur premium" },
];

export const HowItWorks = () => (
  <section className="py-20 md:py-28 bg-white" id="cara-kerja">
    <div className="max-w-7xl mx-auto px-5 md:px-8">
      <SectionHeader
        title="Dari bayar sampai pakai, hitungan menit."
        sub="Semua serba otomatis. Tidak perlu chat admin, tidak perlu menunggu jam kerja."
      />
      <div className="relative grid md:grid-cols-5 gap-6 md:gap-4">
        <div className="hidden md:block absolute top-8 left-[10%] right-[10%] h-0.5 bg-gradient-to-r from-blue-200 via-blue-400 to-cyan-400" />
        {steps.map(({ icon: Icon, title, desc }, i) => (
          <motion.div
            key={title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.6, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="relative flex md:flex-col items-start md:items-center gap-4 md:gap-0 md:text-center"
            data-testid={`step-card-${i + 1}`}
          >
            <div className="relative z-10 shrink-0 w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-600 to-cyan-500 shadow-[0_10px_30px_rgba(37,99,235,0.3)] flex items-center justify-center">
              <Icon className="w-7 h-7 text-white" strokeWidth={2.2} />
              <span className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-white border-2 border-blue-500 flex items-center justify-center font-heading text-xs font-extrabold text-blue-600">
                {i + 1}
              </span>
            </div>
            <div className="md:mt-5">
              <h3 className="font-heading font-bold text-slate-900 text-base md:text-lg">{title}</h3>
              <p className="mt-1 text-sm text-slate-500 leading-relaxed">{desc}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
